import * as R from 'ramda'
import { createSelector } from 'reselect'

// ({ id, name }) => String
export const idSelector = createSelector(
  R.prop('id'),
  R.prop('name'),
  (id, name) => id || name
)

// ({ id, name, label }) => String
export const labelIdSelector = createSelector(
  idSelector,
  R.prop('labelId'),
  (id, labelId) => labelId || `${id}__label`
)

// ({ id, name, errorMessage }) => String
export const errorMessageIdSelector = createSelector(
  idSelector,
  R.prop('errorMessage'),
  (id, errorMessage) => (errorMessage ? `${id}__error-message` : '')
)

// ({ id, name, helpText }) => String
export const helpTextIdSelector = createSelector(
  idSelector,
  R.prop('helpText'),
  (id, helpText) => (helpText ? `${id}__help-text` : '')
)

// ({ id, name, infoText }) => String
export const infoTextIdSelector = createSelector(
  idSelector,
  R.prop('infoText'),
  (id, infoText) => (infoText ? `${id}__info-text` : '')
)

// ({ id, name, subText }) => String
export const subTextIdSelector = createSelector(
  idSelector,
  R.prop('subText'),
  (id, subText) => (subText ? `${id}__sub-text` : '')
)

// ({ id, name, errorMessage, helpText, infoText }) => String
export const describedBySelector = createSelector(
  errorMessageIdSelector,
  helpTextIdSelector,
  infoTextIdSelector,
  (errorMessageId, helpTextId, infoTextId) =>
    [errorMessageId, helpTextId, infoTextId].filter(Boolean).join(' ')
)
